import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { APP_CONFIG } from '../config/constants';

const FooterContainer = styled.footer`
  background: transparent;
  color: rgba(255, 255, 255, 0.8);
  padding: 3rem 2rem;
  text-align: center;
  position: relative;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
`;

const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
`;

const FooterText = styled.p`
  margin-bottom: 0.5rem;
`;

const FooterLink = styled(Link)`
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
  transition: color 0.3s;

  &:hover {
    color: rgba(255, 255, 255, 0.95);
    text-decoration: underline;
  }
`;

const FooterEmailLink = styled.a`
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
  transition: color 0.3s;

  &:hover {
    color: rgba(255, 255, 255, 0.95);
    text-decoration: underline;
  }
`;

const Footer = () => {
  return (
    <FooterContainer>
      <FooterContent>
        <FooterText>&copy; {APP_CONFIG.year} {APP_CONFIG.company}. All rights reserved.</FooterText>
        <FooterText>
          <FooterLink to="/privacy">Privacy Policy</FooterLink> | <FooterLink to="/terms">Terms of Service</FooterLink> | <FooterEmailLink href={`mailto:${APP_CONFIG.email}`}>Contact Support</FooterEmailLink>
        </FooterText>
      </FooterContent>
    </FooterContainer>
  );
};

export default Footer;
